

import React from "react";
import { Outlet } from "react-router-dom";

/*
  Component to manage the entire SITES section
*/
function SpatialRelations() {
  return <Outlet />;
}

export default SpatialRelations;
